import React from 'react';
import AchievementCard from './AchievementCard';
import { achievementsData } from '../../data/achievementsData';

const Achievements = () => {
  return (
    <section id="honors" className="bg-white pb-12 pt-12">
      <div>
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {achievementsData.map((achievement) => (
              <AchievementCard
                key={achievement.id}
                href={achievement.href}
                isExternal={achievement.isExternal}
                icon={achievement.icon}
                title={achievement.title}
                titleContent={achievement.titleContent}
                titleClassName={achievement.titleClassName}
                organization={achievement.organization}
                year={achievement.year}
                description={achievement.description}
                ctaText={achievement.ctaText}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;